import { AsyncPropSelector, ApiProgressLoader } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Popover, Button, ButtonGroup } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { EditIcon } from '@nile/components/src/Icons';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  white-space: ${(props) => (props.wrap ? 'normal' : 'nowrap')};
`;

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;

function TextCell(props) {
  const { cell, params, _ticket, variables } = props;
  const allProps = params || cell.column;
  const { editable, field, actions, accessor, entity } = allProps;
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const [apiProgress, setApiProgress] = useState(false);
  const [apiResult, setApiResult] = useState('');
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        case 'sop':
          serialisedValue = { sopId: val.sopId, name: val.name };
          break;
        case 'site':
          serialisedValue = { name: val.name, id: val.id };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const setApiComplete = (state) => {
    if (props.showProgress) {
      setApiProgress(false);
      setApiResult(state);
    }
    setTimeout(() => {
      setApiResult('');
    }, 2000);
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? typeof fieldValue === 'object'
        ? {
            name: fieldValue.name,
            label: fieldValue.name,
            value: fieldValue.name
          }
        : { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <Field>
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
          entity={entity || 'Ticket'}
          variables={variables}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                if (props.showProgress) {
                  setApiProgress(true);
                }
                actions.save &&
                  actions.save(
                    updatedProperties,
                    ticket,
                    props.data,
                    setApiComplete
                  );
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </Field>
    );
  };

  const renderValue = (displayVal, suffix) => {
    const updatedDisplayVal = `${displayVal}${suffix || ''}`;
    if (field?.name === 'requester' && ticket?.source === 'Agent') {
      return 'System';
    }
    if (cell?.column?.isBold) {
      return <b>{updatedDisplayVal}</b>;
    }
    return updatedDisplayVal;
  };
  //TODO :: render value in a proper way for NA - vignesh
  const displayVal = cell
    ? props.column.subAccessor
      ? cell.value?.[props.column.subAccessor]
      : cell?.value
      ? cell?.value?.name || cell?.value
      : ''
    : ticket[accessor]
    ? typeof ticket[accessor] === 'object'
      ? ticket[accessor].name
        ? ticket[accessor].name
        : ticket[accessor].firstName
        ? ticket[accessor].firstName + ' ' + ticket[accessor].lastName
        : ticket[accessor].label
      : ticket[accessor]
    : '';

  return !popoverActive ? (
    <Wrap
      className={`${editable ? 'editable-cell' : 'cell'}`}
      wrap={cell?.column?.wrap}
    >
      <div
        className={`${cell?.column?.wrap ? '' : 'ellipsis'}`}
        title={displayVal}
      >
        {displayVal ? (
          renderValue(displayVal, cell?.column?.suffix)
        ) : (
          <DisabledTag>
            <FormattedMessage id="app.noData.message" />
          </DisabledTag>
        )}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
      {apiProgress && <ApiProgressLoader isLoading />}
      {apiResult && <ApiProgressLoader isSuccess={apiResult === 'success'} />}
    </Wrap>
  ) : (
    <Wrap className="editable-cell" wrap={cell?.column?.wrap}>
      <div
        className={`${cell?.column?.wrap ? '' : 'ellipsis'}`}
        title={displayVal}
      >
        {displayVal ? (
          renderValue(displayVal, cell?.column?.suffix)
        ) : (
          <DisabledTag>
            <FormattedMessage id="app.noData.message" />
          </DisabledTag>
        )}
      </div>
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        {getTag()}
      </Popover>
    </Wrap>
  );
}

export default TextCell;
